<style scoped>
h2 {
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #667085;
  margin: 12px 0 6px;
}

small {
  color: #888;
}

/*
 * Cabeçalho: identidade do pedido, situação e valor numa faixa só. A grade de
 * nove pares rótulo/valor que existia aqui obrigava a caçar o dado que importa.
 */
.cabecalho-pedido {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eaecf0;
}

.cabecalho-pedido__id {
  font-size: 17px;
  font-weight: bold;
  letter-spacing: -0.2px;
}

.cabecalho-pedido__linha {
  display: flex;
  align-items: center;
  gap: 9px;
  flex-wrap: wrap;
}

.cabecalho-pedido__meta {
  font-size: 12px;
  color: #667085;
  margin-top: 4px;
}

.cabecalho-pedido__valor {
  text-align: right;
  margin-left: auto;
  white-space: nowrap;
}

.cabecalho-pedido__valor strong {
  font-size: 19px;
  font-variant-numeric: tabular-nums;
}

.rotulo-mini {
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #667085;
}

.badge-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.badge-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex: none;
}

.badge-status.is-devolucao_nao_confirmada {
  background: #b42318;
  border: 1px solid #b42318;
  color: #fff;
}

.badge-status.is-falha_integracao {
  background: #fef3f2;
  border: 1px solid #fecdca;
  color: #b42318;
}

.badge-status.is-pago_nao_integrado {
  background: #fffaeb;
  border: 1px solid #fedf89;
  color: #b54708;
}

.badge-status.is-pago_integrado,
.badge-status.is-devolvido,
.badge-status.is-aguardando {
  background: #fff;
  border: 1px solid #e4e7ec;
  color: #667085;
}

/*
 * A crítica do ERP varia de uma frase a um stack trace de milhares de
 * caracteres. Sem limite, o caso extremo empurrava a linha do tempo para o piso
 * e trazia de volta o scroll do modal — o erro ocupava a tela inteira.
 *
 * Recolhido mostra as três primeiras linhas, que é onde mora a mensagem útil;
 * o resto fica atrás do botão, como o retorno técnico da adquirente.
 */
.motivo-cabecalho {
  font-size: 12px;
  color: #912018;
  background: #fef3f2;
  border: 1px solid #fecdca;
  border-radius: 6px;
  padding: 7px 10px;
  margin-top: 10px;
  line-height: 1.45;
  flex: none;
  /* Stack trace tem tokens longos sem espaço, que estouram a caixa na horizontal. */
  overflow-wrap: break-word;
  word-break: break-word;
}

.motivo-cabecalho__texto {
  white-space: pre-wrap;
}

.motivo-cabecalho__texto.is-recolhido {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.motivo-cabecalho__texto.is-expandido {
  max-height: 150px;
  overflow-y: auto;
}

.motivo-cabecalho__acoes {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}

.motivo-cabecalho__botao {
  border: 1px solid #fecdca;
  background: #fff;
  color: #b42318;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 5px;
  cursor: pointer;
}

.motivo-cabecalho__botao:hover {
  border-color: #b42318;
}

/* As três pontas lado a lado: a comparação é o produto da consulta. */
.situacao-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}

@media (max-width: 767.98px) {
  .situacao-grid {
    grid-template-columns: 1fr;
  }
}

.situacao-col {
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 8px 10px;
  background: #f9fafb;
}

.situacao-col h3 {
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #667085;
  margin: 0 0 6px;
}

.situacao-linha {
  font-size: 12px;
  margin-bottom: 2px;
}

.situacao-linha strong {
  color: #344054;
}

/* Dado de diagnóstico, não a resposta que o operador procura. */
.situacao-interna {
  color: #98a2b3;
  border-top: 1px solid #e9ecef;
  margin-top: 4px;
  padding-top: 4px;
}

.situacao-indisponivel {
  font-size: 12px;
  color: #d92d20;
  background: #fef3f2;
  border-radius: 4px;
  padding: 6px 8px;
}

.situacao-vazio {
  font-size: 12px;
  color: #98a2b3;
  border: 1px dashed #e9ecef;
  border-radius: 6px;
  padding: 8px 10px;
  background: #fff;
}

.situacao-devolucao {
  font-size: 11px;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 4px;
  padding: 4px 6px;
  margin-top: 4px;
}

.situacao-parcial {
  font-size: 12px;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 6px;
}

/* Identificador longo: cinza pequeno é para não competir, mas precisa ser copiável. */
.identificador {
  display: flex;
  align-items: center;
  gap: 6px;
  border-top: 1px solid #eaecf0;
  margin-top: 8px;
  padding-top: 7px;
}

.identificador code {
  font-size: 10px;
  color: #98a2b3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: none;
  padding: 0;
}

.botao-copiar {
  border: 1px solid #e4e7ec;
  background: #fff;
  color: #667085;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
  flex: none;
}

.botao-copiar:hover {
  border-color: #98a2b3;
  color: #344054;
}

/*
 * Linha do tempo como lista de blocos. Era uma tabela cuja coluna Detalhe
 * imprimia o JSON cru da adquirente em 10 linhas de monospace — um evento
 * ficava mais alto que a tela.
 */
.evento {
  display: grid;
  grid-template-columns: 100px 1fr 130px 100px;
  gap: 10px;
  align-items: flex-start;
  padding: 9px 12px;
  border-bottom: 1px solid #f2f4f7;
}

.evento:last-child {
  border-bottom: 0;
}

.evento.is-falha {
  background: #fffbfa;
}

.evento__titulo {
  font-size: 12.5px;
  font-weight: 600;
  color: #101828;
}

.evento__detalhe {
  font-size: 12px;
  color: #475467;
  line-height: 1.45;
  margin-top: 3px;
}

.evento__data {
  font-size: 11.5px;
  color: #667085;
  white-space: nowrap;
}

.evento__valor {
  font-size: 12px;
  color: #344054;
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/*
 * O scroll é da linha do tempo, não do modal. Ela é a única parte que cresce
 * sem limite — um pedido com muitas tentativas empurrava os botões de ação para
 * fora da tela, e era preciso rolar o modal inteiro para alcançá-los.
 */
/*
 * O tema impõe `max-height` + `overflow: auto` no `.tab-content` do CTabs, e é
 * dele que vinha o scroll externo: o conteúdo do modal passava da altura da aba
 * e os botões de ação saíam de vista.
 *
 * A correção é de layout, não de constante — a área da aba vira coluna flex e a
 * linha do tempo absorve a sobra. Qualquer `max-height` fixa aqui erra, porque o
 * espaço disponível depende da tela e do tamanho do bloco de situação (que muda
 * depois de "Verificar situação").
 */
::v-deep .tab-content {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

::v-deep .tab-pane.active {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}

.lista-eventos {
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  overflow-y: auto;
  flex: 1;
  /* Nunca some de todo: abaixo disso é melhor rolar a aba que ficar ilegível.
     Com a barra de ações fixa, rolar não esconde mais os botões. */
  min-height: 100px;
}

/* O cabeçalho e a barra de ações não cedem espaço: quem encolhe é a lista. */
.cabecalho-pedido,
.acoes-modal {
  flex: none;
}

.lista-eventos__vazio {
  font-size: 12px;
  color: #98a2b3;
  padding: 14px;
  text-align: center;
}

/* Marca de qual fonte contou o evento: adquirente, operador ou rotina. */
.origem-item {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 8px;
  font-size: 9px;
  font-weight: bold;
  text-transform: uppercase;
  white-space: nowrap;
  color: #fff;
}

.origem-item.is-transacao {
  background: #321fdb;
}

.origem-item.is-acao_operador {
  background: #3399ff;
}

.origem-item.is-automacao {
  background: #6c757d;
}

.botao-tecnico {
  border: 1px solid #e4e7ec;
  background: #fff;
  color: #475467;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 6px;
}

.botao-tecnico:hover {
  border-color: #98a2b3;
  color: #101828;
}

.retorno-tecnico {
  margin-top: 7px;
  border: 1px solid #e4e7ec;
  border-radius: 6px;
  background: #f9fafb;
  padding: 9px 11px;
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 3px 10px;
}

.retorno-tecnico__chave {
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #98a2b3;
}

.retorno-tecnico__valor {
  font-size: 11.5px;
  color: #344054;
  font-family: monospace;
  word-break: break-all;
}

/*
 * Fixa no rodapé da aba. Condensar o conteúdo resolve a maioria das telas, mas
 * não todas — e a queixa original era ter de rolar para achar os botões. Sticky
 * garante que eles fiquem alcançáveis mesmo quando o conteúdo não couber.
 */
.acoes-modal {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 11px 0 2px;
  border-top: 1px solid #eaecf0;
  position: sticky;
  bottom: 0;
  background: #fff;
  z-index: 2;
}

.acoes-modal__espaco {
  flex: 1;
}

/* Separa a consulta, que não altera nada, das duas ações que alteram o pedido. */
.acoes-modal__divisor {
  width: 1px;
  height: 26px;
  background: #e4e7ec;
  margin: 0 4px;
}
/*
 * Tela baixa: aperta o que é diagnóstico (motivo e piso da linha do tempo) para
 * o conteúdo caber sem rolar. No caso extremo — motivo enorme expandido junto do
 * bloco de situação preenchido — a aba ainda rola, e é a barra de ações fixa que
 * garante que os botões continuem alcançáveis.
 */
@media (max-height: 720px) {
  .motivo-cabecalho__texto.is-recolhido {
    -webkit-line-clamp: 2;
  }

  .motivo-cabecalho__texto.is-expandido {
    max-height: 96px;
  }

  h2 {
    margin: 8px 0 5px;
  }

  .lista-eventos {
    min-height: 70px;
  }

  /* É instrução, não dado: é o primeiro lugar de onde tirar altura. */
  .situacao-vazio {
    padding: 6px 8px;
    font-size: 11px;
  }

  .cabecalho-pedido {
    padding-bottom: 6px;
  }
}
</style>

<template>
  <modal
    name="info-transacao-pix"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
  >
    <div class="modalbox" v-if="!!pedido.id">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab title="Detalhes do Pedido">
            <div class="cabecalho-pedido">
              <div>
                <div class="cabecalho-pedido__linha">
                  <span class="cabecalho-pedido__id">{{ pedido.id }}</span>
                  <span
                    class="badge-status"
                    :class="`is-${pedidoAtual.status.chave}`"
                  >
                    <span
                      class="badge-status__dot"
                      :style="{ background: corDoPonto }"
                    ></span>
                    {{ pedidoAtual.status.label }}
                  </span>
                </div>
                <div class="cabecalho-pedido__meta">
                  {{ pedido.cliente.id }} - {{ pedido.cliente.razSoc }} ·
                  doc. {{ pedido.cliente.doc }} · {{ pedido.origem }} ·
                  {{ pedido.data | date }} ·
                  {{ pedido.adquirente.nome }} ({{ pedido.adquirente.gateway }})
                </div>
              </div>
              <div class="cabecalho-pedido__valor">
                <div class="rotulo-mini">Valor</div>
                <strong>{{ pedido.valor | monetary }}</strong>
              </div>
            </div>

            <div v-if="pedido.motivo" class="motivo-cabecalho">
              <div
                class="motivo-cabecalho__texto"
                :class="motivoExpandido ? 'is-expandido' : 'is-recolhido'"
              >{{ pedido.motivo }}</div>
              <div v-if="motivoEhLongo" class="motivo-cabecalho__acoes">
                <button
                  type="button"
                  class="motivo-cabecalho__botao"
                  v-on:click="motivoExpandido = !motivoExpandido"
                >
                  <fa-icon :icon="motivoExpandido ? 'chevron-up' : 'chevron-down'" />
                  {{ motivoExpandido ? 'recolher motivo' : 'ver motivo completo' }}
                </button>
                <button
                  type="button"
                  class="motivo-cabecalho__botao"
                  v-on:click="copiar(pedido.motivo)"
                >
                  <fa-icon icon="copy" /> copiar
                </button>
              </div>
            </div>

            <h2>Situação do pagamento</h2>
            <div v-if="carregandoSituacao" class="situacao-vazio">
              Consultando a adquirente e o ERP...
            </div>
            <div v-else-if="erroSituacao" class="situacao-indisponivel">
              {{ erroSituacao }}
            </div>
            <div v-else-if="!situacao" class="situacao-vazio">
              Clique em "Verificar situação" para consultar a adquirente e o ERP
              agora. Se a adquirente confirmar um pagamento que falta nesta base,
              ele é registrado.
            </div>
            <div v-else>
              <div v-if="situacaoParcial" class="situacao-parcial">
                {{ situacao.detalhe }}
              </div>
              <div class="situacao-grid">
                <div class="situacao-col">
                  <h3>Adquirente</h3>
                  <template v-if="pspRespondeu">
                    <div class="situacao-linha">
                      <strong>{{ situacaoDoPsp }}</strong>
                    </div>
                    <div class="situacao-linha">
                      Valor: {{ situacao.psp.valor | monetary }}
                    </div>
                    <div class="situacao-linha">Status: {{ situacao.psp.statusPsp }}</div>
                    <div
                      v-for="(devolucao, i) in situacao.psp.devolucoes"
                      :key="`devolucao-${i}`"
                      class="situacao-devolucao"
                    >
                      Devolução {{ devolucao.status }} — {{ devolucao.valor }}
                    </div>
                    <div class="identificador">
                      <code>{{ situacao.psp.e2eId || '—' }}</code>
                      <button
                        v-if="situacao.psp.e2eId"
                        class="botao-copiar"
                        type="button"
                        title="Copiar"
                        v-on:click="copiar(situacao.psp.e2eId)"
                      >
                        <fa-icon icon="copy" />
                      </button>
                    </div>
                  </template>
                  <div v-else class="situacao-indisponivel">
                    {{ situacao.psp.mensagem }}
                    <span v-if="situacao.psp.httpCode">
                      (HTTP {{ situacao.psp.httpCode }})
                    </span>
                  </div>
                </div>

                <div class="situacao-col">
                  <h3>ERP</h3>
                  <template v-if="erpRespondeu">
                    <div class="situacao-linha">
                      <strong>
                        {{
                          situacao.erp.pedidoExiste
                            ? 'Pedido encontrado'
                            : 'Pedido não encontrado'
                        }}
                      </strong>
                    </div>
                    <template v-if="situacao.erp.pedido">
                      <div class="situacao-linha">
                        Número: {{ situacao.erp.pedido.id || '—' }}
                      </div>
                      <div class="situacao-linha">
                        Status: {{ situacao.erp.pedido.status || '—' }}
                      </div>
                      <div class="situacao-linha">
                        Nota: {{ situacao.erp.pedido.numnf || '—' }}
                      </div>
                    </template>
                  </template>
                  <div v-else class="situacao-indisponivel">
                    {{ situacao.erp.mensagem }}
                  </div>
                </div>

                <div class="situacao-col">
                  <h3>Nesta base</h3>
                  <div class="situacao-linha">
                    <strong>{{ situacao.local.badge.label }}</strong>
                  </div>
                  <div class="situacao-linha">
                    Pagamento confirmado:
                    {{ situacao.local.pagamentoConfirmado ? 'sim' : 'não' }}
                  </div>
                  <div class="situacao-linha">
                    Valor: {{ situacao.local.valor | monetary }}
                  </div>
                  <div class="situacao-linha situacao-interna">
                    Marcação interna: {{ situacao.local.situacaoPagamentoLabel }}
                  </div>
                  <div
                    v-if="situacao.local.aviso"
                    class="situacao-linha situacao-indisponivel"
                  >
                    {{ situacao.local.aviso }}
                  </div>
                  <div class="identificador">
                    <code>{{ situacao.local.transactionId || '—' }}</code>
                    <button
                      v-if="situacao.local.transactionId"
                      class="botao-copiar"
                      type="button"
                      title="Copiar"
                      v-on:click="copiar(situacao.local.transactionId)"
                    >
                      <fa-icon icon="copy" />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <h2>Linha do tempo</h2>
            <div class="lista-eventos">
              <div
                v-for="t in timeline"
                :key="`${t.tipo}-${t.extra.id}`"
                class="evento"
                :class="{ 'is-falha': eventoFalhou(t) }"
              >
                <div>
                  <span class="origem-item" :class="`is-${t.tipo}`">
                    {{ origemLabel(t.tipo) }}
                  </span>
                </div>
                <div>
                  <div class="evento__titulo">{{ t.titulo }}</div>
                  <div class="evento__detalhe">{{ t.detalhe || '—' }}</div>
                  <!--
                    O retorno da adquirente fica atrás de um botão: é onde
                    aparece a recusa que explica o caso, mas como padrão ele
                    empurrava o resto da linha do tempo para fora da tela.
                  -->
                  <button
                    v-if="temRetornoTecnico(t)"
                    class="botao-tecnico"
                    type="button"
                    v-on:click="alternarTecnico(t)"
                  >
                    <fa-icon :icon="tecnicoAberto(t) ? 'chevron-up' : 'chevron-down'" />
                    {{ tecnicoAberto(t) ? 'ocultar retorno técnico' : 'retorno técnico da adquirente' }}
                  </button>
                  <div v-if="tecnicoAberto(t)" class="retorno-tecnico">
                    <template v-for="campo in camposTecnicos(t)">
                      <div
                        class="retorno-tecnico__chave"
                        :key="`${chaveDoEvento(t)}-k-${campo.chave}`"
                      >
                        {{ campo.rotulo }}
                      </div>
                      <div
                        class="retorno-tecnico__valor"
                        :key="`${chaveDoEvento(t)}-v-${campo.chave}`"
                      >
                        {{ campo.valor }}
                      </div>
                    </template>
                  </div>
                </div>
                <div class="evento__data">{{ t.data | date }}</div>
                <div class="evento__valor">{{ formatValor(t.valor) }}</div>
              </div>
              <div v-if="timeline.length === 0" class="lista-eventos__vazio">
                Sem movimentações registradas
              </div>
            </div>

            <div class="acoes-modal">
              <button class="button" type="button" v-on:click="close">
                Fechar
              </button>
              <div class="acoes-modal__espaco"></div>
              <button
                class="button button-info"
                type="button"
                :disabled="carregandoSituacao"
                v-on:click="verificarSituacao"
              >
                {{ carregandoSituacao ? 'Consultando...' : 'Verificar situação' }}
              </button>
              <span
                v-if="podeIntegrar || podeEstornar"
                class="acoes-modal__divisor"
              ></span>
              <button
                v-if="podeIntegrar"
                class="button button-primary"
                type="button"
                v-on:click="integrar(pedido)"
              >
                <fa-icon icon="sync" /> Integrar pedido
              </button>
              <button
                v-if="podeEstornar"
                class="button button-error"
                type="button"
                v-on:click="estornar(pedido)"
              >
                <fa-icon icon="undo" /> Estornar pagamento
              </button>
            </div>
          </CTab>
        </CTabs>
      </div>
    </div>
  </modal>
</template>

<script>
import { get } from '../../helpers/apiRequest';
import { podeEstornar, podeIntegrar, statusAtual } from './statusPix';

/**
 * Rótulos dos campos que a adquirente devolve. A chave crua vale como rótulo
 * quando o PSP manda algo fora desta lista — o bloco existe para diagnosticar,
 * então esconder um campo desconhecido seria pior que exibi-lo sem tradução.
 */
const ROTULO_TECNICO = {
  status: 'Status',
  motivo: 'Motivo',
  message: 'Mensagem',
  detail: 'Detalhe',
  title: 'Título',
  type: 'Tipo',
  code: 'Código HTTP',
  id: 'ID da devolução',
  rtrId: 'RTR',
  valor: 'Valor',
  natureza: 'Natureza',
  txid: 'TXID',
  chave: 'Chave PIX',
  revisao: 'Revisão',
  solicitacaoPagador: 'Solicitação ao pagador',
};

const COR_DO_PONTO = {
  devolucao_nao_confirmada: '#fff',
  falha_integracao: '#dd514c',
  pago_nao_integrado: '#f9b115',
  pago_integrado: '#2eb85c',
  devolvido: '#6c757d',
  aguardando: '#adb5bd',
};

export default {
  name: 'info-transacao-pix',
  props: ['pedido', 'integrar', 'estornar', 'close', 'recarregar'],
  data() {
    return {
      situacao: null,
      carregandoSituacao: false,
      erroSituacao: null,
      tecnicosAbertos: {},
      motivoExpandido: false,
    };
  },
  computed: {
    timeline() {
      return this.pedido.timeline || [];
    },
    pedidoAtual() {
      return { status: statusAtual(this.pedido, this.situacao) || {} };
    },
    podeIntegrar() {
      return podeIntegrar(this.pedidoAtual);
    },
    podeEstornar() {
      return podeEstornar(this.pedidoAtual);
    },
    /**
     * Só oferece expandir quando há o que expandir: a crítica curta cabe nas
     * três linhas e um botão ali viraria ruído.
     */
    motivoEhLongo() {
      return (this.pedido.motivo || '').length > 180;
    },
    corDoPonto() {
      return COR_DO_PONTO[this.pedidoAtual.status.chave] || '#adb5bd';
    },
    pspRespondeu() {
      return this.situacao && this.situacao.psp.estado === 'ok';
    },
    erpRespondeu() {
      return this.situacao && this.situacao.erp.estado === 'ok';
    },
    situacaoParcial() {
      return this.situacao && this.situacao.resultado !== 'SUCESSO';
    },
    /**
     * Os quatro indicadores da adquirente são excludentes; o texto único evita
     * que o operador some quatro booleanos com o olho.
     */
    situacaoDoPsp() {
      const psp = this.situacao.psp;

      if (psp.pago) return 'Pago';
      if (psp.devolvido) return 'Devolvido';
      if (psp.cancelado) return 'Cancelado';
      if (psp.emAberto) return 'Em aberto';

      return 'Indeterminado';
    },
  },
  watch: {
    /**
     * O modal não é destruído entre aberturas: sem limpar, o operador abriria
     * outro pedido e leria a consulta do anterior como se fosse deste.
     *
     * Observa o objeto, não o `id`: reabrir o MESMO pedido também precisa voltar
     * ao estado inicial, senão o motivo continua expandido e os retornos
     * técnicos seguem abertos da visita anterior.
     */
    pedido: function () {
      this.situacao = null;
      this.erroSituacao = null;
      this.carregandoSituacao = false;
      this.tecnicosAbertos = {};
      this.motivoExpandido = false;
    },
  },
  methods: {
    verificarSituacao() {
      if (this.carregandoSituacao) {
        return;
      }

      this.carregandoSituacao = true;
      this.erroSituacao = null;
      this.situacao = null;

      get(`/admin/pix-acompanhamento/${this.pedido.id}/situacao`)
        .then((json) => {
          this.situacao = json.data;

          if (this.situacao.local && this.situacao.local.pagamentoRegistrado) {
            this.recarregar();
          }
        })
        .catch((error) => {
          this.erroSituacao = error.message;
        })
        .finally(() => {
          this.carregandoSituacao = false;
        });
    },
    origemLabel(tipo) {
      return (
        {
          transacao: 'Adquirente',
          acao_operador: 'Operador',
          automacao: 'Rotina',
        }[tipo] || tipo
      );
    },
    chaveDoEvento(evento) {
      return `${evento.tipo}-${evento.extra.id}`;
    },
    /**
     * Tinge só o evento que terminou mal. Ler a linha do tempo do pedido com
     * problema é procurar onde ela deu errado.
     */
    eventoFalhou(evento) {
      const resultado = evento.extra && evento.extra.resultado;

      return resultado === 'FALHA' || resultado === 'RECUSADO';
    },
    temRetornoTecnico(evento) {
      return this.camposTecnicos(evento).length > 0;
    },
    tecnicoAberto(evento) {
      return !!this.tecnicosAbertos[this.chaveDoEvento(evento)];
    },
    alternarTecnico(evento) {
      const chave = this.chaveDoEvento(evento);

      // $set porque a chave nasce depois da instância: sem ele o Vue 2 não
      // observa a propriedade nova e o bloco não abre.
      this.$set(this.tecnicosAbertos, chave, !this.tecnicosAbertos[chave]);
    },
    /**
     * A resposta chega do backend já sem os blocos aninhados, que é onde a
     * adquirente põe os dados do pagador. Aqui só se decide a ordem e o rótulo.
     */
    camposTecnicos(evento) {
      const resposta = evento.extra && evento.extra.resposta;

      if (!resposta || typeof resposta !== 'object') {
        return [];
      }

      return Object.keys(resposta)
        .filter((chave) => {
          const valor = resposta[chave];

          return valor !== null && valor !== undefined && valor !== '';
        })
        .map((chave) => ({
          chave,
          rotulo: ROTULO_TECNICO[chave] || chave,
          valor: String(resposta[chave]),
        }));
    },
    copiar(texto) {
      if (!texto || !navigator.clipboard) {
        return;
      }

      navigator.clipboard.writeText(texto);
    },
    /**
     * O filtro precisa ser chamado como método: dentro de parênteses o Vue 2
     * não interpreta `|` como filtro, e sim como OR bitwise — o que trunca o
     * valor e ainda procura uma propriedade chamada `monetary` na instância.
     */
    formatValor(valor) {
      if (valor === null || valor === undefined) {
        return '—';
      }

      return this.$options.filters.monetary(valor);
    },
  },
};
</script>
